var App = App || {};

var player;

var $play = $("#play");
var $pause = $("#pause");

App.PageMatheadHome = (function ($) {
    'use strict';

    var Bps = ["xs", "sm", "md"],
        Bp = ZAGFramework.GetCurrentBP(),
        Mobile = false;

    function init() {
        var $pageMasthead = $(".page-masthead-home"),
            $videoContainer = $pageMasthead.find(".video-container");

        if ($videoContainer.length) {
            var tag = document.createElement("script");
            var firstScriptTag = document.getElementsByTagName("script")[0];

            if ($videoContainer.hasClass("is-youtube")) {
                tag.src = "https://www.youtube.com/player_api";
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

            if ($videoContainer.hasClass("is-vimeo")) {
                var iframe = document.querySelector("#video");
                var player = new Vimeo.Player(iframe);

                player.on("loaded", function () {
                    onVimeoPlayerAPIReady(player);
                });
            }
        }

        if (Bps.includes(Bp)) {
            Mobile = true;
        }

        $(document).on("enter-xs enter-sm enter-md", function () {
            Mobile = true;
        });
        $(document).on("enter-lg enter-xl enter-xxl", function () {
            Mobile = false;
        });

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PageMatheadHome.init();
});


function onYouTubePlayerAPIReady() {
    player = new YT.Player("video", {
        events: {
            "onReady": onYouTubePlayerReady,
            "onStateChange": onYouTubePlayerStateChange
        }
    });
}

function onYouTubePlayerReady(event) {
    event.target.playVideo();

    $play.on("click", function () {
        player.playVideo();

        $play.addClass("d-none");

        $pause
            .removeClass("d-none")
            .focus();
    });

    $pause.on("click", function () {
        player.pauseVideo();

        $pause.addClass("d-none");

        $play
            .removeClass("d-none")
            .focus();
    });
}

function onYouTubePlayerStateChange(event) {
    if (event.data == "1") {
        $play.addClass("d-none");
        $pause.removeClass("d-none");
    }

    if (event.data == "2") {
        $pause.addClass("d-none");
        $play.removeClass("d-none");
    }
}

function onVimeoPlayerAPIReady(player) {
    player
        .play()
        .then(function () {
            $play.addClass("d-none");
            $pause.removeClass("d-none");

            onVimeoPlayerStateChange(player);
        });

    $play.on("click", function () {
        onVimeoPlayerStateChange(player);

        player
            .play()
            .then(function () {
                $play.addClass("d-none");

                $pause
                    .removeClass("d-none")
                    .focus();
            }).catch(function (error) {
                console.log(error);
            });

    });

    $pause.on("click", function () {
        onVimeoPlayerStateChange(player);

        player
            .pause()
            .then(function () {
                $pause.addClass("d-none");

                $play
                    .removeClass("d-none")
                    .focus();
            }).catch(function (error) {
                console.log(error);
            });
    });
}

function onVimeoPlayerStateChange(player) {
    player.on("play", function () {
        $play.addClass("d-none");
        $pause.removeClass("d-none");
    });

    player.on("pause", function () {
        $pause.addClass("d-none");
        $play.removeClass("d-none");
    });
}